export default __webpack_public_path__ + "static/media/Grace-Collection-pricelist_2021-400x482.a2d28760.jpg";